<template>
  <el-dialog
    title="Select your idols"
    :visible.sync="dialog_visible"
    @open="onLoad"
    width="75%">

    <div class="d-block">

      <el-checkbox-group v-model="clone">
        <el-row :gutter="12">
          <el-col :span="6" v-for="(idol, key) in idols" :key="'idol-'+key">
            <el-card :body-style="{ padding: '0px' }">
              <div class="idol-img" :style="{ backgroundImage: imgurl(idol.pic) }" :title="idol.quotes[0]"></div>
              <div style="padding: 14px;">
                <div class="bottom clearfix">
                  <el-checkbox :disabled="loading" :label="idol.id">{{idol.name}}</el-checkbox>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-checkbox-group>

      <!-- <pre>{{idols}}</pre> -->
      <!-- <pre>{{clone}}</pre> -->
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSaveSettings">OK</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialog_visible: false,
      clone: []
    }
  },
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),

    ...mapGetters("calendar", [
      "idols"
    ]),

    loading() {
      return this.idols.length === 0;
    },
  },
  methods: {
    // ...mapActions("calendar", [
    //   "fetch_idols_from_firestore"
    // ]),

    showModal() {
      this.dialog_visible = true;
    },
    onLoad() {

      if ( this.userData  && 'selectedIdols' in this.userData) {
        this.clone = this.userData.selectedIdols;
      } else {
        this.clone = [];
      }

      // this.fetch_idols_from_firestore().then((idols) => {
      //   console.log("DONE", idols);
      //   // this.fetch_quote_from_favqs
      // });

      // this.loading = true
      // if ( this.userData  && 'selectedIdols' in this.userData) {
      //   this.clone = [];
      //   this.loading = true
      //
      //   oldRealTimeDb
      //     .ref('idols')
      //     .limitToFirst(100)
      //     .once("value", (snapshot) => {
      //       let val = snapshot.val();
      //       this.idols = [];
      //       Object.keys(val).map(key => {
      //         if ( this.userData.selectedIdols.includes( key ) ) {
      //           this.clone.push(key)
      //         }
      //         this.idols.push({ id: key, ...val[key] });
      //       });
      //
      //       this.loading = false;
      //     });
      // }
    },
    onSaveSettings() {
      this.$api.user_update_settings_by_prefix({
        data: this.clone,
        prefix: 'selectedIdols'
      }).then(() => {
        console.log( "Successfully updated user selectedIdols" );
        this.dialog_visible = false;
        this.$emit('save');
      });
    },
    imgurl(img) {
      return `url('${img}')`;
    }
  }
};
</script>

<style>
.idol-img {
  width: 180.5px;
  height: 180.5px;
  background-position: 50% 25%;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
